import React, { useState, useEffect } from "react";
import Logo from "Assets/logo.png";
import Styles from "./Styles.module.css";
import Button from "Components/Button";
import { FiUser, FiLock } from "react-icons/fi";
import { BiLogInCircle } from "react-icons/bi";
import { useNavigate, NavLink } from "react-router-dom";

interface MenuItemProps {
    label: string;
    LinkTo: string;
}
interface ButtonTypes {
    Title: string;
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
    Theme?: "Dark" | "Light";
    icon?: React.ReactNode;
    fontWeight?: number | string;
}
interface MenuDropdownProps {
    label: string;
    isOpen: boolean;
    onClick: () => void;
    items: MenuItemType[];
}

interface MenuItemType {
    label: string;
    subItems?: MenuItemType[];
    LinkTo?: string;
}

const Menu: React.FC = () => {
    const Navigate = useNavigate();
    const [menuActive, setMenuActive] = useState<boolean>(false);
    const [mobileMenuActive, setMobileMenuActive] = useState<boolean>(false);
    const [openedDropdowns, setOpenedDropdowns] = useState<number[]>([]);

    useEffect(() => {
        const bodyClass = mobileMenuActive
            ? "mobile-menu-active hide-scrolling"
            : "";
        document.body.className = bodyClass;

        return () => {
            document.body.className = "";
        };
    }, [mobileMenuActive]);

    const toggleMenu = () => {
        setMenuActive(!menuActive);
        setMobileMenuActive(!mobileMenuActive);
    };

    const handleDropdownClick = (index: number) => {
        setOpenedDropdowns((prevOpenedDropdowns) =>
            prevOpenedDropdowns.includes(index)
                ? prevOpenedDropdowns.filter((i) => i !== index)
                : [...prevOpenedDropdowns, index]
        );
    };

    return (
        <div className={Styles.wrapper}>
            <img src={Logo} alt="Logo" />
            <div className={Styles.contain}>
                <div className={Styles["container"]}>
                    <div className={Styles["menu-open"]} onClick={toggleMenu}>
                        <span className={Styles["open"]}></span>
                    </div>
                    <div
                        className={`${Styles["ozmenu"]}  ${
                            menuActive ? Styles["active"] : ""
                        }`}>
                        <div
                            className={Styles["menu-close"]}
                            onClick={toggleMenu}>
                            <span className={Styles["close"]}></span>
                        </div>
                        <ul className={Styles["ozmenu-nav"]}>
                            <MenuItem label="Home" LinkTo="/" />
                            <MenuItem label="About Us" LinkTo="/about-us" />
                            <MenuItem label="Why serene" LinkTo="/why-serene" />
                            <MenuDropdown
                                label="Services"
                                isOpen={openedDropdowns.includes(0)}
                                onClick={() => handleDropdownClick(0)}
                                items={[
                                    {
                                        label: "Individual Service",
                                        subItems: [
                                            {
                                                label: "Federal and State Tax Returns",
                                                LinkTo: "/Preparation-of-federal-and-state-tax-returns",
                                            },
                                            {
                                                label: "Advance Tax Planning",
                                                LinkTo: "/Advance-tax-planning",
                                            },
                                            {
                                                label: " Amendment Tax Returns",
                                                LinkTo: "/filing-of-amendment-tax-returns-claim-for-refund",
                                            },
                                            {
                                                label: "IRS Audit Representation",
                                                LinkTo: "/irs-audit-representation",
                                            },
                                            {
                                                label: "ITIN Application (W7)",
                                                LinkTo: "/preparation-of-itin",
                                            },
                                            {
                                                label: "Extension of Tax Returns",
                                                LinkTo: "/extension-of-tax-returns",
                                            },
                                        ],
                                    },

                                    {
                                        label: "Business Service",
                                        subItems: [
                                            {
                                                label: "Business Tax returns",
                                                LinkTo: "/Business-tax-returns",
                                            },
                                            {
                                                label: "Annual filing or Franchise taxes",
                                                LinkTo: "/Annual-filing-or-Franchise-taxes",
                                            },
                                            {
                                                label: "Bookkeeping Services",
                                                LinkTo: "/Bookkeeping-Services",
                                            },
                                            {
                                                label: "Payroll Services",
                                                LinkTo: "/payroll-services",
                                            },
                                            {
                                                label: "New Business Registration",
                                                LinkTo: "/New-Business-Registration",
                                            },
                                        ],
                                    },
                                    {
                                        label: "Foreign Reporting",
                                        subItems: [
                                            { label: "FBAR", LinkTo: "/FBAR" },
                                            {
                                                label: "FATCA",
                                                LinkTo: "/FATCA",
                                            },
                                            {
                                                label: "Non-resident Alien",
                                                LinkTo: "/non-resident",
                                            },
                                        ],
                                    },
                                ]}
                            />

                            <MenuItem label="Pricing" LinkTo="/pricing" />
                            <MenuItem label="Contact" LinkTo="/Contact" />
                            <li>
                                <div
                                    className={`${Styles["action-btns"]} ${Styles["action-btns-mobile"]}`}>
                                    <MenuItemButton
                                        Title="Login"
                                        onClick={() => {
                                            Navigate("/Login");
                                        }}
                                        Theme="Dark"
                                        fontWeight={600}
                                        icon={<BiLogInCircle size={16} />}
                                    />
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div
                        id="menu-overlay"
                        className={mobileMenuActive ? Styles["show"] : ""}
                        onClick={toggleMenu}></div>
                </div>
                <div className={Styles["action-btns"]}>
                    <MenuItemButton
                        Title="Login"
                        onClick={() => {
                            Navigate("/Login");
                        }}
                        Theme="Dark"
                        fontWeight={600}
                        icon={<BiLogInCircle size={16} />}
                    />
                </div>
            </div>
        </div>
    );
};

const MenuItem: React.FC<MenuItemProps> = ({ label, LinkTo }) => (
    <li className={Styles["item"]}>
        <NavLink
            to={LinkTo}
            className={({ isActive }) => (isActive ? Styles["active"] : "")}>
            {label}
        </NavLink>
    </li>
);
const MenuItemButton: React.FC<ButtonTypes> = ({
    icon,
    Title,
    onClick,
    Theme,
    fontWeight,
}) => (
    <>
        {/*  <a href="#">{label}</a> */}
        <Button
            Title={Title}
            onClick={onClick}
            Theme={Theme}
            icon={icon}
            fontWeight={fontWeight}
        />
    </>
);

const MenuDropdown: React.FC<MenuDropdownProps> = ({
    label,
    isOpen,
    onClick,
    items,
}) => (
    <li className={`${Styles["item"]} ${Styles["dropdownitem"]}`}>
        <a
            // href="#"
            className={`${Styles["nav-dropdown"]} ${
                isOpen ? Styles["opened"] : ""
            }`}
            onClick={onClick}>
            {label}
        </a>
        {isOpen && (
            <div className={Styles["dropdown"]}>
                <ul>
                    {items.map((item, index) =>
                        item.subItems ? (
                            <MenuDropdown
                                key={index}
                                label={item.label}
                                isOpen={isOpen}
                                onClick={onClick}
                                items={item.subItems}
                            />
                        ) : (
                            <MenuItem
                                key={index}
                                label={item.label}
                                LinkTo={item?.LinkTo || ""}
                            />
                        )
                    )}
                </ul>
            </div>
        )}
    </li>
);

export default Menu;
